import { createApp } from 'vue'
import MaterialCard from './MaterialCard'

const el = '.kb-component--material-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((MaterialCardDOM) => {
            const component = createApp(MaterialCard).use(Store)
            component.mount(MaterialCardDOM)
        })
    }
}
